// extracted by mini-css-extract-plugin
module.exports = {"ArticleContent":"ArticleRichTextParser_ArticleContent__3ttGQ"};